<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="rgba(255, 255, 255, 0.8)"
      color="#1A237E"
      spinner="mini-spinner"
    />

    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showsnackbar" color="#1A237E" right rounded="pill">
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="showsnackbar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-row class="mb-4 px-4">
      <v-col cols="12" class="d-flex align-center">
        <h2 class="page-title">User Management</h2>
        <v-chip class="ml-4" color="primary" outlined small label>
          Total Users: {{ totalLength }}
        </v-chip>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>

    <v-card flat class="rounded-xl elevation-1 overflow-hidden mx-4">
      <v-row class="grey lighten-4 pa-4 d-none d-lg-flex" no-gutters>
        <v-col lg="4" class="text-subtitle-2 grey--text text--darken-2">NAME & DETAILS</v-col>
        <v-col lg="3" class="text-subtitle-2 grey--text text--darken-2 text-center">PHONE</v-col>
        <v-col lg="2" class="text-subtitle-2 grey--text text--darken-2 text-center">STATUS</v-col>
        <v-col lg="3" class="text-subtitle-2 grey--text text--darken-2 text-right pr-6">ACTIONS</v-col>
      </v-row>

      <v-divider></v-divider>

      <v-layout wrap v-if="userList.length > 0">
        <v-flex xs12 v-for="(item, i) in userList" :key="i">
          <v-hover v-slot="{ hover }">
            <v-card 
              tile 
              flat 
              :class="hover ? 'blue lighten-5' : ''" 
              class="transition-swing border-bottom"
            >
              <v-row class="pa-4 align-center" no-gutters>
                <v-col cols="12" lg="4" class="py-1">
                  <div class="d-flex align-center">
                    <v-avatar size="40" color="#1A237E" class="mr-3 elevation-2">
                      <span class="white--text font-weight-bold">{{ item.first_name ? item.first_name.charAt(0) : 'U' }}</span>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold grey--text text--darken-4">
                        {{ item.first_name }} {{ item.last_name }}
                      </div>
                      <div class="caption grey--text">{{ item.role || 'Standard User' }}</div>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" lg="3" class="py-1 text-lg-center">
                  <span class="text-body-2 font-weight-medium">
                    <v-icon x-small color="grey" class="mr-1">mdi-phone</v-icon>
                    {{ item.phone }}
                  </span>
                </v-col>

                <v-col cols="12" lg="2" class="py-1 text-lg-center">
                  <v-chip 
                    small 
                    :color="item.status === 'Active' ? 'success' : 'grey lighten-1'"
                    class="font-weight-bold white--text px-4"
                  >
                    {{ item.status || 'Active' }}
                  </v-chip>
                </v-col>

                <v-col cols="12" lg="3" class="py-1 text-right pr-lg-4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        class="mr-2"
                        :to="'/admin/userview?id=' + item._id"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View Profile</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="confirmDelete(item)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete User</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>

      <v-row v-else class="pa-16 justify-center text-center">
        <v-col cols="12">
          <v-icon size="80" color="grey lighten-3">mdi-account-search-outline</v-icon>
          <h3 class="grey--text text--lighten-1 mt-4">No users found</h3>
        </v-col>
      </v-row>
    </v-card>

    <div class="text-center pt-8 pb-4">
      <v-pagination
        v-model="page"
        :length="pagelength"
        circle
        color="#1A237E"
        :total-visible="7"
      ></v-pagination>
    </div>

    <v-dialog v-model="deleteDialog" max-width="450" persistent>
      <v-card class="rounded-xl pa-6 text-center">
        <v-avatar color="red lighten-5" size="70" class="mb-4">
          <v-icon size="40" color="red accent-3">mdi-alert-decagram</v-icon>
        </v-avatar>
        <h3 class="headline mb-2 font-weight-bold">Confirm Deletion</h3>
        <p class="body-2 grey--text text--darken-1">
          Are you sure you want to remove <b>{{ selectedUser.first_name }} {{ selectedUser.last_name }}</b>? 
          This will permanently delete their account from the system.
        </p>
        <v-card-actions class="pb-0">
          <v-spacer></v-spacer>
          <v-btn text rounded large class="px-6" @click="deleteDialog = false">Keep User</v-btn>
          <v-btn color="error" rounded depressed large class="px-8" @click="deleteItem">
            Yes, Delete
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "UserList",
  data() {
    return {
      userList: [],
      page: 1,
      limit: 20,
      pagelength: 1,
      totalLength: 0,
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      msg: "",
      
      // Modal Logic
      deleteDialog: false,
      selectedUser: {},
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/getall/users",
        method: "post",
        data: {
          page: this.page,
          limit: this.limit,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
      .then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          this.userList = response.data.data;
          this.totalLength = response.data.totalLength || 0;
          this.pagelength = Math.ceil(this.totalLength / this.limit);
        } else {
          this.showsnackbar = true;
          this.msg = response.data.msg;
        }
      })
      .catch((err) => {
        this.appLoading = false;
        this.ServerError = true;
        console.error("Fetch Error:", err); // FIXED ESLint: variable is used
      });
    },

    confirmDelete(user) {
      this.selectedUser = user;
      this.deleteDialog = true;
    },

    deleteItem() {
      this.deleteDialog = false;
      this.appLoading = true;
      axios({
        url: "/admin/remove/user",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: { id: this.selectedUser._id },
      })
      .then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          this.msg = "User successfully removed";
          this.showsnackbar = true;
          this.getData();
        } else {
          this.msg = response.data.msg;
          this.showsnackbar = true;
        }
      })
      .catch((err) => {
        this.appLoading = false;
        this.ServerError = true;
        console.error("Delete Error:", err); // FIXED ESLint: variable is used
      });
    },
  },
};
</script>

<style scoped>
.page-title {
  font-family: 'Syne', sans-serif;
  font-weight: 800;
  color: #1A237E;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-size: 1.4rem;
}

.border-bottom {
  border-bottom: 1px solid #f1f3f5 !important;
}

/* Pagination Customization */
::v-deep .v-pagination__item {
  box-shadow: none !important;
  border: 1px solid #e9ecef;
  font-weight: 600;
}

::v-deep .v-pagination__item--active {
  box-shadow: 0 4px 12px rgba(26, 35, 126, 0.2) !important;
}

/* Global Transition for Hover */
.transition-swing {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>